<template>
  <RevDrawer
    has-back-button
    :name="MODAL_NAME"
    :title="i18n(translations.drawerTitle)"
    @back="handleGoBack"
  >
    <template #body>
      <div class="space-y-24">
        <div class="body-1-bold">{{ categoryGroup.name }}</div>
        <RevList :has-external-borders="false">
          <template #default>
            <RevListItemStatic v-for="category in categories" :key="category">
              <template #label>
                {{ category }}
              </template>
            </RevListItemStatic>
          </template>
        </RevList>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevList } from '@ds/components/List'
import { RevListItemStatic } from '@ds/components/ListItemStatic'
import { closeModal } from '@ds/components/ModalBase'

import { MODAL_NAMES } from '../../../../Shipping.constants'
import type { ShippingCategoryGroupDetailed } from '../../CategoryList.types'

import translations from './CategoryGroupDetailsDrawer.translations'

const MODAL_NAME = MODAL_NAMES.CATEGORY_DETAILS

const props = defineProps<{
  categoryGroup: ShippingCategoryGroupDetailed
}>()

const i18n = useI18n()

const categories = computed(() =>
  props.categoryGroup.shippingCategories.map((category) => category.name),
)

function handleGoBack() {
  closeModal(MODAL_NAME)
}
</script>
